import { useEffect, useRef } from "react";
import { Loader2, Send } from "lucide-react";

export const ChatComposer = ({ value, onChange, onSend, busy, large }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "0px";
    el.style.height = Math.min(el.scrollHeight, large ? 260 : 200) + "px";
  }, [value, large]);

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSend(); }
  };

  return (
    <form onSubmit={(e) => { e.preventDefault(); onSend(); }} className="apx-glass rounded-2xl p-2 md:p-3 flex items-end gap-2 md:gap-3 border border-slate-700/70 focus-within:border-cyan-700/70 transition-colors" data-testid="chat-composer">
      <textarea
        ref={ref}
        data-testid="chat-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKey}
        rows={1}
        placeholder={typeof window !== "undefined" && window.innerWidth < 640 ? "Ask EV-IDEX anything…" : "Ask EV-IDEX about a coin, an opportunity, an indicator or a strategy…"}
        className="flex-1 bg-transparent outline-none resize-none px-3 py-3 text-[1rem] md:text-[1.05rem] leading-7 min-h-[52px] placeholder:text-slate-500"
      />
      <button
        type="submit"
        data-testid="chat-send"
        disabled={busy || !value.trim()}
        className="btn-primary rounded-xl h-[52px] px-5 md:px-6 flex items-center gap-2 text-[0.95rem] font-semibold disabled:opacity-50 shrink-0"
      >
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />} <span>Send</span>
      </button>
    </form>
  );
};
